import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { RefObject } from "react";

import Dialog from "../form/dialog.comp";
import { deleteProductFile } from "../../core/productFile.core";
import { useTranslation } from "../../core/translation.core";

interface DeleteProductFileDialogProps {
  dialogRef: RefObject<HTMLDialogElement>;
  productFileId: string;
  clickCancelled?: VoidFunction;
}

export default function DeleteProductFileDialog({ dialogRef, productFileId, clickCancelled }: DeleteProductFileDialogProps) {
  const { t, msg } = useTranslation();
  const queryClient = useQueryClient();
  const { isReady } = useRouter();

  async function clickConfirmed() {
    await deleteProductFile(productFileId);
    queryClient.invalidateQueries({ queryKey: ["productFiles"] });
  }

  if (!isReady) return null;

  return (
    <Dialog
      title={t(msg.productFile.deleteTitle)}
      message={t(msg.productFile.deleteConfirm)}
      dialogRef={dialogRef}
      confirm={clickConfirmed}
      cancel={clickCancelled}
    />
  );
}
